export enum Account {
  INDEX = '/account',
  EDIT = '/account/edit',
}
